import { Component } from '@angular/core';

@Component({
  selector: 'app-image-preview-icon-action-playground',
  templateUrl: './image-preview-icon-action-playground.component.html',
  styleUrls: ['./image-preview-icon-action-playground.component.scss'],
})
export class ImagePreviewIconActionPlaygroundComponent {
  imageUrl?: string;
  disabled = false;
  lastEvent = '';

  onAction(): void {
    this.lastEvent = `action @ ${new Date().toLocaleTimeString()}`;
    if (!this.imageUrl) {
      this.imageUrl = 'https://picsum.photos/seed/ipia-playground/172/172';
    }
  }

  clearPreview(): void {
    this.imageUrl = undefined;
    this.lastEvent = `clear @ ${new Date().toLocaleTimeString()}`;
  }
}
